import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import { useContext } from 'react';
import { FormText } from 'ui/styled';
import WrapperImport from '../WrapperImport';
import { CompanyButtonContainer } from './styled';

export default function ModalLog({ itensErros, itensCorretos }) {
  const { setModal } = useContext(CoreContext);
  const close = () => setModal(null);
  let totErros = 0;

  itensErros.forEach(function (item, index) {
    totErros++;
  });

  return (
    <WrapperImport>
      <h5>Total de Registros lidos {totErros + itensCorretos}</h5>
      <h5 style={{ color: 'green' }}>Importados com sucesso {itensCorretos}</h5>
      <h5 style={{ color: 'red' }}>Não importados {totErros}</h5>
      {totErros > 0 ? (
        <>
          <hr></hr>
          {itensErros.map((item) => (
            <FormText>
              Erro na Linha: {item.linha} erro: {item.erro} -- Remova do
              arquivo!
            </FormText>
          ))}
        </>
      ) : (
        <></>
      )}
      {/* <FormText>Erro na Linha: {item.linha}</FormText> */}
      <CompanyButtonContainer>
        <Button onClick={close}>Fechar</Button>
      </CompanyButtonContainer>
    </WrapperImport>
  );
}
